<template>
  <div>
<!--    <v-app>-->
    <my-asidebar v-bind:active-tab="'settings'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>

      <div class="dashboard-content-wrap">

        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">

            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Group Rezervasyonu</h2>
                    <v-app>
                      <template>
                        <v-file-input
                            show-size
                            v-model="excelInput"
                            label="File input"
                            @change="inputChanged"
                        ></v-file-input>
                      </template>
                      <v-autocomplete class="pl-4"
                          :filter="filterAgents"
                                      :items="userList"
                                      v-model="selectedAgent"
                                      flat hide-no-data
                                      hide-details
                                      item-value="id"
                                      placeholder="Acente">
                        <template slot="selection" slot-scope="{ item, selected }">
                          {{item.email}}
                        </template>
                        <template slot="item" slot-scope="{ item, tile }">
                          <v-list-tile-content>
                            {{item.email}}
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete class="pl-4 mb-10"
                                      :filter="filterSails"
                                      :items="sailList"
                                      v-model="selectedSail"
                                      flat hide-no-data
                                      hide-details
                                      item-value="id"
                                      placeholder="Sefer">
                        <template slot="selection" slot-scope="{ item, selected }">
                          {{item.sailDate | ddMMyyyy}}
                        </template>
                        <template slot="item" slot-scope="{ item, tile }">
                          <v-list-tile-content>
                            {{item.sailDate | ddMMyyyy}}
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                      <v-text-field
                          v-model="targetPrice"
                          label="Hedef Fiyat"
                          type="number"
                      ></v-text-field>
<!--                      <base-select-input-->
<!--                          v-model="selectedAgent"-->
<!--                          :textkey="['email']"-->
<!--                          :label="'Agent'"-->
<!--                          :option-list="userList"-->
<!--                      ></base-select-input>-->
<!--                      <base-select-input-->
<!--                          v-model="selectedSail"-->
<!--                          :textkey="['id']"-->
<!--                          :label="'Sail'"-->
<!--                          :option-list="sailList"-->
<!--                      ></base-select-input>-->
                    </v-app>
                  </div>
                </div>

              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/settings'" class="text-white">Ayarlar</a></li>
                  </ul>
                </div>

              </div>

            </div>

          </div>

        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid">
            <div class="row" v-for="(bookingData,index) in bookingImportDatas">
              <div class="col-lg-12">
                <form id="portForm">
                  <div class="form-box">
                    <div class="form-content pb-2">
                      <h3 class="title mb-3">{{ index+1 }}. Kişi </h3>


                      <div class="row justify-content-between">
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.cabinNo"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Room Number'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.firstName + ' ' + bookingData.middleName"
                              :rules="'required'"
                              :type="'text'"
                              :label="'İsim'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.lastName"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Soyisim'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.birthDate"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Doğum Tarihi'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.gender"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Cinsiyet'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.passport"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Pasaport'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.tckNo"
                              :type="'text'"
                              :label="'Tc No'"
                          ></base-edit-input>
                        </div>

                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.expireDate"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Son Geçerlilik Tarihi'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.issuePlace"
                              :rules="'required'"
                              :type="'text'"
                              :label="'Verildiği Yer'"
                          ></base-edit-input>
                        </div>
                        <div class="col-lg-3 responsive-column">
                          <base-edit-input
                              v-model="bookingData.bedOption"
                              :type="'text'"
                              :label="'Yatak Seçimi'"
                          ></base-edit-input>
                        </div>
                       </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <button v-if="bookingImportDatas && bookingImportDatas.length > 1" :class="{'disabled' : !formValid}" @click="createGroupReservation" class="theme-btn" type="button">Kaydet</button>

      </div>

    </section>
<!--    </v-app>-->
  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";
import messagePopupManager from "../util/messagePopupManager";
import BaseSelectInput from "../component/base/BaseSelectInput";
import BaseEditInput from "../component/base/BaseEditInput";
import ExchangeRateHistoryPopup from "../component/booking/ExchangeRateHistoryPopup";
import {ddMMyyyy} from "../util/filters";

export default {
  name: "GroupReservationPage",
  components: {BaseEditInput, BaseSelectInput, TopBar, MyAsidebar},
  data:function (){
    return{
      excelInput: null,
      bookingImportDatas : [],
      selectedAgent : null,
      selectedSail : null,
      targetPrice : 0
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    },
    userList:{
      get(){
        return this.$store.getters.getAgencyUserList;
      },
    },
    sailList:{
      get(){
        return this.$store.getters.getSailsLite;
      },
    },
  },
  mounted() {
    debugger
    this.$store.dispatch("loadUserList");
    this.$store.dispatch("loadSailsLite");
    // if(!this.panelRights["PANEL_PAGE_SETTINGS"]) this.$router.push("/");
  },
  methods: {
    filterAgents(row, searchTerm){
      let email = row.email;
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        if(email.toLowerCase().includes(searchTerm)){
          matchCount++;
        }
      })
      return matchCount === splitSearchTerm.length;
    },
    filterSails(row, searchTerm){

      let date = moment(row.sailDate).format('DD/MM/YYYY');
      let splitSearchTerm = searchTerm.toLowerCase().split(" ");

      let matchCount = 0;
      splitSearchTerm.forEach(searchTerm=> {
        if(date.toLowerCase().includes(searchTerm)){
          matchCount++;
        }
      })
      return matchCount === splitSearchTerm.length;
    },
    inputChanged(){
      this.$store.dispatch("importGroupReservationExcel", this.excelInput).then((response)=>{
        this.bookingImportDatas = response;
      })
    },
    createGroupReservation() {
      let request = {};
      request.bookingImportDatas = this.bookingImportDatas
      request.agentId = this.selectedAgent;
      request.sailId = this.selectedSail;
      request.targetPrice = this.targetPrice;

      this.$store.dispatch("createGroupReservation", request).then(response=>{
        messagePopupManager.showSuccess();
      }).catch((error)=>{
        console.log(error)
        debugger
        messagePopupManager.showError("Hata", error.response.data.message);
      })
    }
  }
}
</script>

<style scoped>

</style>